module.exports = __webpack_public_path__ + "static/media/block.adeaf268.svg";